/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Contract_SigningInputs */

const cs_enum_contract_signing = /** @type {(inputs: Enum_Contract_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podpis smlouvy`)
};

const en_enum_contract_signing = /** @type {(inputs: Enum_Contract_SigningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract signing`)
};

/**
* | output |
* | --- |
* | "Contract signing" |
*
* @param {Enum_Contract_SigningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_contract_signing = /** @type {((inputs?: Enum_Contract_SigningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Contract_SigningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_contract_signing(inputs)
	return cs_enum_contract_signing(inputs)
});